
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/opt/app-root/src/website/sentry.client.config.ts")
            }
          });